import diff from './diff.js';
import addedDiff from './added.js';
import deletedDiff from './deleted.js';
import updatedDiff from './updated.js';
import detailedDiff from './detailed.js';

export {
  addedDiff,
  diff,
  deletedDiff,
  updatedDiff,
  detailedDiff
};



//////////////////
// WEBPACK FOOTER
// ./~/deep-object-diff/mjs/index.js
// module id = 271
// module chunks = 61